import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { subscription } from '~data/selectors/user';
import { loadSubscription } from '~data/actions/user';

import { Layout, Separator } from '~ui';
import Alert from './alert';
import Status from './status';
import Period from './period';
import Price from './price';
import Actions from './actions';
import Help from './help';

export default function SettingsProPaid(props) {
  const sub = useSelector(subscription);
  const dispatch = useDispatch();

  useEffect(() => {
    const load = () => dispatch(loadSubscription());
    load();
    window.addEventListener('focus', load);
    return () => window.removeEventListener('focus', load);
  }, [dispatch]);

  const childrenProps = { ...props, subscription: sub };

  return (
    <Layout type='grid'>
      <Alert {...childrenProps} />

      <Status {...childrenProps} />
      <Price {...childrenProps} />
      <Period {...childrenProps} />

      <Separator />

      <Actions {...childrenProps} />

      <Separator />

      <Help {...childrenProps} />
    </Layout>
  );
}
